import { Component, Input } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { Goal } from '@models/performance/goal.model';

@Component({
    selector: 'app-form-goal-details',
    templateUrl: './goal-details.template.html',
})
export class GoalDetailsForm extends BaseForm {
    @Input() goal: Goal;

    constructor() {
        super();
    }
}
